<p-toast />

<section class="flex flex-column gap-3">
  @if (!informada()) {
    <div>
      <h1 class="hidden md:block text-2xl font-semibold text-color m-0 mb-2">Tomar lista</h1>
      <p class="m-0 text-color-secondary">
        @if (elegirLider()) {
          Elegí un líder y marcá quién asistió de su célula esta semana.
        } @else {
          Dile a tu pastor quién asistió de tu célula esta semana.
        }
      </p>
    </div>
  }

  @if (elegirLider()) {
    <div class="tomar-lista__columna flex flex-column gap-2">
      <label class="text-sm font-medium text-color" for="tomar-lista-lider">Líder</label>
      <p-select
        inputId="tomar-lista-lider"
        [options]="opcionesLider()"
        optionLabel="label"
        optionValue="id"
        [ngModel]="liderSeleccionado()"
        (ngModelChange)="alCambiarLider($event)"
        [disabled]="loading() || enviando()"
        [filter]="opcionesLider().length > 8"
        filterPlaceholder="Buscar líder"
        appendTo="body"
        styleClass="w-full"
        placeholder="Elegí un líder"
      />
    </div>
  }

  @if (loading()) {
    <app-skeleton-block variant="list" [rows]="8" />
  } @else if (elegirLider() && opcionesLider().length === 0) {
    <p class="m-0 text-color-secondary">No hay líderes para tomar lista.</p>
  } @else if (elegirLider() && filas().length === 0 && !enviada()) {
    <p class="m-0 text-color-secondary">Este líder no tiene personas pendientes.</p>
  } @else if (enviada() || filas().length === 0) {
    <div class="flex flex-column align-items-center text-center gap-3 py-6">
      <i class="pi pi-check-circle tomar-lista__ok" aria-hidden="true"></i>
      <div>
        <p class="m-0 text-xl font-semibold">¡Muy bien!</p>
        <p class="m-0 mt-2 text-color-secondary">
          @if (elegirLider()) {
            La asistencia de esta célula fue informada.
          } @else {
            La asistencia de tus discípulos fue informada.
          }
        </p>
      </div>
      <div class="flex flex-column align-items-center gap-2">
        <p-button type="button" label="Ir al muelle" routerLink="/muelle" />
        <button type="button" class="tomar-lista__cuando" (click)="abrirCuando()">
          ¿Cuándo tomé lista?
        </button>
      </div>
    </div>
  } @else {
    <div class="tomar-lista__columna flex flex-column gap-3">
    @for (persona of filas(); track persona.id) {
      <article class="tomar-lista__tarjeta">
        <div class="tomar-lista__persona">
          <span
            class="tomar-lista__iniciales"
            [class.tomar-lista__iniciales--mujer]="esMujer(persona)"
            aria-hidden="true"
          >{{ iniciales(persona) }}</span>
          <div class="min-w-0">
            <p class="tomar-lista__nombre m-0">{{ nombreCompleto(persona) }}</p>
            @if (cumple(persona); as cumple) {
              <p class="tomar-lista__cumple m-0">
                Cumple años el {{ cumple.fecha }}.
                @if (cumple.aviso) {
                  <span class="tomar-lista__aviso">{{ cumple.aviso }}.</span>
                }
              </p>
            }
            @if (contexto()?.mostrarLider) {
              <p class="tomar-lista__cumple m-0">Líder: {{ persona.miLider }}</p>
            }
          </div>
        </div>

        @if (!contexto()?.abierta) {
          <div>
            <p class="m-0 text-sm">Persona sin informar.</p>
            <p class="m-0 mt-1 text-sm text-color-secondary">
              El envío de asistencias ya ha cerrado.
            </p>
          </div>
        } @else {
          <div class="tomar-lista__marcas">
            <div class="tomar-lista__marca">
              <p class="tomar-lista__marca-titulo">{{ contexto()?.celulaName }}</p>
              <span
                class="tomar-lista__estado"
                [class.tomar-lista__estado--presente]="estado(persona.asistencia.celula) === 'presente'"
                [class.tomar-lista__estado--ausente]="estado(persona.asistencia.celula) === 'ausente'"
              >{{ estadoLabel(persona.asistencia.celula) }}</span>
              <div class="tomar-lista__opciones">
                <button
                  type="button"
                  class="tomar-lista__opcion"
                  [class.tomar-lista__opcion--presente]="persona.asistencia.celula === true"
                  [attr.aria-pressed]="persona.asistencia.celula === true"
                  (click)="marcar(persona.id, 'celula', true)"
                >
                  <i class="pi pi-user" aria-hidden="true"></i>
                  Presente
                </button>
                <button
                  type="button"
                  class="tomar-lista__opcion"
                  [class.tomar-lista__opcion--ausente]="persona.asistencia.celula === false"
                  [attr.aria-pressed]="persona.asistencia.celula === false"
                  (click)="marcar(persona.id, 'celula', false)"
                >
                  <i class="pi pi-times" aria-hidden="true"></i>
                  Ausente
                </button>
              </div>
            </div>

            <div class="tomar-lista__marca">
              <p class="tomar-lista__marca-titulo">Domingo</p>
              <span
                class="tomar-lista__estado"
                [class.tomar-lista__estado--presente]="estado(persona.asistencia.domingo) === 'presente'"
                [class.tomar-lista__estado--ausente]="estado(persona.asistencia.domingo) === 'ausente'"
              >{{ estadoLabel(persona.asistencia.domingo) }}</span>
              <div class="tomar-lista__opciones">
                <button
                  type="button"
                  class="tomar-lista__opcion"
                  [class.tomar-lista__opcion--presente]="persona.asistencia.domingo === true"
                  [attr.aria-pressed]="persona.asistencia.domingo === true"
                  (click)="marcar(persona.id, 'domingo', true)"
                >
                  <i class="pi pi-user" aria-hidden="true"></i>
                  Presente
                </button>
                <button
                  type="button"
                  class="tomar-lista__opcion"
                  [class.tomar-lista__opcion--ausente]="persona.asistencia.domingo === false"
                  [attr.aria-pressed]="persona.asistencia.domingo === false"
                  (click)="marcar(persona.id, 'domingo', false)"
                >
                  <i class="pi pi-times" aria-hidden="true"></i>
                  Ausente
                </button>
              </div>
            </div>
          </div>
        }
      </article>
    }

    @if (contexto()?.abierta) {
      <p-button
        class="tomar-lista__enviar"
        type="button"
        [label]="enviando() ? 'Enviando...' : 'Enviar todo'"
        icon="pi pi-send"
        styleClass="w-full"
        [disabled]="enviando() || !puedeEnviar()"
        (onClick)="enviar()"
      />
    }
    </div>
  }
</section>

<p-dialog
  [visible]="cuandoVisible()"
  (visibleChange)="cuandoVisible.set($event)"
  header="¿Cuándo tomé lista?"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: '24rem' }"
>
  @if (cuandoCargando()) {
    <p class="m-0 text-color-secondary">Buscando...</p>
  } @else {
    <p class="m-0">{{ cuandoTexto() }}</p>
  }
  <div class="flex justify-content-end pt-3">
    <p-button type="button" label="Aceptar" (onClick)="cuandoVisible.set(false)" />
  </div>
</p-dialog>
